import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "headline-5 my-capitalize",
  style: {"margin":"auto 0px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Articles", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Contacts", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Resources", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_notification_bell = _resolveComponent("notification-bell")!
  const _component_help_button = _resolveComponent("help-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_skeleton_feed = _resolveComponent("skeleton-feed")!
  const _component_articles_feed = _resolveComponent("articles-feed")!
  const _component_contact_feed = _resolveComponent("contact-feed")!
  const _component_resource_feed = _resolveComponent("resource-feed")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_resources_in_area = _resolveComponent("resources-in-area")!
  const _component_other_articles_box = _resolveComponent("other-articles-box")!
  const _component_upcoming_events_box = _resolveComponent("upcoming-events-box")!
  const _component_sidebar_box = _resolveComponent("sidebar-box")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { onClick: _ctx.scrollTop }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, {
                slot: "start",
                class: "ion-hide-lg-up"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_notification_bell, {
                    parent: _ctx.$parent!.$refs.ionRouterOutlet
                  }, null, 8, ["parent"]),
                  _createVNode(_component_help_button)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { class: "w100" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_grid, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, { class: "px-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                size: "12",
                                class: "flex"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h5", _hoisted_1, "Search " + _toDisplayString(_ctx.tab), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "mx-4 pa-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_searchbar, {
                                autocorrect: "on",
                                spellcheck: "",
                                modelValue: _ctx.search,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                                placeholder: "Search",
                                color: "white",
                                debounce: "300",
                                onIonChange: _ctx.load,
                                enterkeyhint: "enter",
                                "show-cancel-button": "never",
                                inputmode: "search",
                                onKeyup: _withKeys(_ctx.closeMe, ["enter"])
                              }, null, 8, ["modelValue", "onIonChange", "onKeyup"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "px-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                size: "12",
                                class: "flex px-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_segment, {
                                    onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.segmentChanged($event))),
                                    modelValue: _ctx.tab,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_segment_button, { value: "articles" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-hide-sm-down" }, {
                                            default: _withCtx(() => [
                                              _hoisted_2
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_icon, {
                                            class: "ion-hide-sm-up",
                                            icon: _ctx.newspaperOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_segment_button, { value: "contacts" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-hide-sm-down" }, {
                                            default: _withCtx(() => [
                                              _hoisted_3
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_icon, {
                                            class: "ion-hide-sm-up",
                                            icon: _ctx.peopleOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_segment_button, { value: "resources" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-hide-sm-down" }, {
                                            default: _withCtx(() => [
                                              _hoisted_4
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_icon, {
                                            class: "ion-hide-sm-up",
                                            icon: _ctx.folderOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-justify-content-center px-2 mx-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                "size-lg": "12",
                                "size-md": "12",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.loading)
                                    ? (_openBlock(), _createBlock(_component_skeleton_feed, { key: 0 }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.loading && _ctx.tab == 'articles')
                                    ? (_openBlock(), _createBlock(_component_articles_feed, { key: 1 }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.loading && _ctx.tab == 'contacts')
                                    ? (_openBlock(), _createBlock(_component_contact_feed, { key: 2 }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.loading && _ctx.tab == 'resources')
                                    ? (_openBlock(), _createBlock(_component_resource_feed, { key: 3 }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.$store.state.user.innerWidth > 1400)
                    ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_sidebar_box, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_resources_in_area),
                              _createVNode(_component_other_articles_box, { title: "Related Articles" }),
                              _createVNode(_component_upcoming_events_box, { class: "mt-2" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_infinite_scroll, {
            onIonInfinite: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMore($event))),
            threshold: "100px",
            id: "infinite-scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "crescent" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}